import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Home, Compass } from 'lucide-react';
import PageTransition from '../components/common/PageTransition';
import SEOHead from '../components/common/SEOHead';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageTransition>
      <SEOHead title="404" />
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
        <div className="art-card p-8 sm:p-12 rounded-3xl max-w-md w-full space-y-6 relative overflow-hidden">
          <div className="space-y-2">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-indigo-500/10 text-indigo-500 dark:text-indigo-400 text-xs font-semibold border border-indigo-500/20">
              <Compass className="w-3.5 h-3.5" />
              <span>Erreur 404</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 dark:text-white tracking-tight">
              {t('common.error404')} ☁️
            </h2>
          </div>

          <div className="py-2">
            <img
              className="mx-auto rounded-2xl w-32 h-32 object-cover border-2 border-indigo-500/30 cursor-pointer hover:scale-105 transition duration-300 shadow-xl"
              src="/img/Sky_00.gif"
              alt="404"
              onClick={() => navigate('/')}
            />
          </div>

          <div className="pt-2">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-semibold text-sm transition-all shadow-lg w-full"
            >
              <Home className="w-4 h-4" />
              <span>{t('common.backToHome')}</span>
            </Link>
          </div>
        </div>
      </div>
    </PageTransition>
  );
};

export default NotFound;
